import script from "./PreLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./PreLoader.vue?vue&type=script&setup=true&lang=js"

import "./PreLoader.vue?vue&type=style&index=0&id=0d86093e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d86093e"]])

export default __exports__